/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Formatting_LabelInputs */



/**
* | output |
* | --- |
* | "Formatting" |
*
* @param {Style_Guide_Manager_Formatting_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_formatting_label = /** @type {((inputs?: Style_Guide_Manager_Formatting_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Formatting_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise en forme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Formatierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форматирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("格式化")
	if (locale === "ja") return /** @type {LocalizedString} */ ("書式設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("का प्रारूपण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação")
	return /** @type {LocalizedString} */ ("Formatting")
});